import { Component, OnInit, Inject } from '@angular/core';
import { PageComponent, ICC_PAGE_DATA } from '@icc/configurator/shared';
import { SharedFacade } from '@icc/configurator/shared';
import { IccMaterial } from '@icc/shared/types/api/material';
import { UntypedFormBuilder, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { isNotNullOrUndefined } from '@icc/shared/helpers';

export interface SystemFilters {
    type: IccMaterial;
    groupId: number;
    tags: string[];
}

@Component({
    selector: 'icc-system-filters',
    templateUrl: './system-filters.component.html',
    styleUrls: ['./system-filters.component.scss'],
    standalone: false
})
export class SystemFiltersComponent extends PageComponent implements OnInit {
    public title = 'Filtry';

    filtersGroup = this.fb.group({
        type: [''],
        groupId: [''],
        tags: this.fb.array([])
    });

    systemTypes: any[] = [];
    systemGroups: any[] = [];
    systemTags: any[] = [];

    constructor(
        @Inject(ICC_PAGE_DATA)
        private pageData: {
            filters: SystemFilters;
            systemTypes: any[];
            systemGroups: any[];
            systemTags: any[];
        },
        private sharedFacade: SharedFacade,
        private fb: UntypedFormBuilder
    ) {
        super();
        pageData.systemTags.forEach(tag => {
            const formArray = this.filtersGroup.get('tags') as UntypedFormArray;
            if (formArray) {
                formArray.push(new UntypedFormControl(false))
            }
        });
    }

    ngOnInit() {
        this.systemTypes = this.pageData.systemTypes;
        this.systemGroups = this.pageData.systemGroups;
        this.systemTags = this.pageData.systemTags;
        if (this.pageData.filters) {
            this.filtersGroup.setValue({

                    type: this.pageData.filters.type || '',
                    groupId: this.pageData.filters.groupId || '',
                    tags: this.systemTags.map(tag => this.pageData.filters.tags.includes(tag.id))
            });
        }
    }
    save() {
        this.sharedFacade.closeFilterSheet({
            filters: {
                ...this.filtersGroup.value,
                tags: this.filtersGroup.value.tags.map((checked: boolean, i: number) => checked ? this.systemTags[i].id : null).filter(isNotNullOrUndefined)
            }
        });
    }
}
